import { createLogic } from 'redux-logic';
import {
  PROPOSALS_URL,
  CANCEL_PROPOSALS_URL,
  CANCEL_NEW_PROPOSALS_URL,
} from 'utils/api';
import { toastr } from 'react-redux-toastr';

import { getToday } from 'utils/helpers';

import {
  LOAD_PROPOSALS,
  CANCEL_PROPOSAL,
  CANCEL_NEW_OPERATIONS_PROPOSAL,
} from '../constants/proposals';
import {
  LoadProposalsSuccess,
  LoadProposalsError,
  CancelNewOperationsProposalSuccess,
  CancelNewOperationsProposalError,
} from '../actions/proposals';
import { normalizeProposalsFilters, normalizeProposals, colorStatus } from '../models/proposals';

const getParamFiltered = (filters) => {
  const params = [];
  filters.forEach((filter) => {
    filter.options.forEach((option) => {
      if (option.isSelected) {
        params.push(`Filtros.${filter.name}=${option.id}`);
      }
    });

    if (filter.type === 'date' && filter.extraParam) {
      params.push(filter.extraParam.map(param => `Filtros.${param.name}=${param.id}`).join('&'));
    }
  });

  return params.length > 0 ? `?${params.join('&')}` : [];
};

const LoadProposals = createLogic({
  type: LOAD_PROPOSALS,
  latest: true,

  process({ requestUtil, action }, dispatch, done) {
    const { payload } = action;

    const paramFilters = payload && payload.length > 0
      ? getParamFiltered(payload)
      : `?Filtros.listaDataContratacao=${getToday()}`;

    requestUtil(PROPOSALS_URL + paramFilters)
      .then((response) => {
        if (!response.error) {
          const { propostas, filtro } = response;

          const proposals = propostas ? normalizeProposals(propostas) : [];
          const filters = filtro ? normalizeProposalsFilters(filtro) : [];

          dispatch(LoadProposalsSuccess({
            proposals, filters,
          }));
        } else {
          toastr.error('Tenta novamente', 'Falha ao carregar as informações');
          dispatch(LoadProposalsError());
        }
      }).then(done);
  },
});

const CancelProposal = createLogic({
  type: CANCEL_PROPOSAL,
  latest: true,
  process({ requestUtil, action, getState }, dispatch, done) {
    requestUtil(CANCEL_PROPOSALS_URL, {
      method: 'PATCH',
      data: {
        orderId: action.proposalId,
      },
    })
      .then((response) => {
        const { error } = response;
        const { Proposals } = getState();

        if (!error) {
          const newProposals = Proposals.proposals
            .map(p => ({
              ...p,
              status: p.codigoOrdem !== action.proposalId
                ? p.status
                : {
                  ...response.novoStatus,
                  color: colorStatus(response.novoStatus.id),
                },
            }));

          dispatch(LoadProposalsSuccess({
            proposals: newProposals, filters: Proposals.filters,
          }));
        } else {
          toastr.error('Tenta novamente', 'Falha ao cancelar a proposta');
          dispatch(LoadProposalsSuccess({
            proposals: Proposals.proposals, filters: Proposals.filters,
          }));
        }
      })
      .then(done);
  },
});

const CancelNewOperationsProposal = createLogic({
  type: CANCEL_NEW_OPERATIONS_PROPOSAL,
  latest: true,
  process({ requestUtil, action }, dispatch, done) {
    requestUtil(CANCEL_NEW_PROPOSALS_URL.replace('{codigoOrdem}', action.proposalId), {
      method: 'POST',
    })
      .then((response) => {
        const { error } = response;

        if (!error) {
          dispatch(CancelNewOperationsProposalSuccess(action.proposalId));
        } else {
          toastr.error('Tente novamente', error?.response?.data?.mensagem || 'Falha ao cancelar a proposta');
          dispatch(CancelNewOperationsProposalError());
        }
      })
      .then(done);
  },
});

export default [LoadProposals, CancelProposal, CancelNewOperationsProposal];
